import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-catalogue-tree',
  templateUrl: './catalogue-tree.component.html',
  styleUrls: ['./catalogue-tree.component.css']
})
export class CatalogueTreeComponent implements OnInit {
  // 目录树数据
  @Input() treelists: any
  // 选中的目录id
  @Input() selectedMenuId1:any = '';
  //编辑目录：抛出事件
  @Output() editClick = new EventEmitter(); 
  //删除目录：抛出事件
  @Output() deleteClick = new EventEmitter(); 
  //选中目录：抛出事件
  @Output() selectClick = new EventEmitter(); 
  selectedMenuId = '';
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }){
    // 目录树数据发生变化时，需清除选中的目录
    if(changes['treelists']){
      this.selectedMenuId = '';
      this.selectClick.emit(this.selectedMenuId);
    }
    if(changes['selectedMenuId1']){
      this.selectedMenuId = this.selectedMenuId1;
      this.selectClick.emit(this.selectedMenuId);
    }
  }

  // 目录展开/关闭
  itemClick(item) {
    item.isOpen = !item.isOpen;
    this.selectMenu(item.menuId);
  }

  // 选中的目录层级
  selectMenu(menuId){
    this.selectedMenuId = menuId;
    this.selectClick.emit(this.selectedMenuId);
  }

  // 目录操作：编辑、删除
  toolbarClick(menuId,state){
    this.selectMenu(menuId);
    if(state == 'edit'){
      this.editClick.emit(menuId);
    }
    if(state == 'delete'){
      this.deleteClick.emit(menuId);
    }
  }
}
